import { useState } from 'react';
import { InlineStatus } from './InlineStatus';

interface Props {
  contentUrl: string;
  filename: string;
}

// Simple <img> preview. The browser streams the presigned S3 GET
// directly — we don't fetch bytes into JS memory. Fall back to an
// error panel if the image fails to load (S3 403, expired presign,
// corrupt bytes).
export function ImageView({ contentUrl, filename }: Props) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <InlineStatus label="Image failed to load. Try Download." error />;
  }

  return (
    <div className="flex min-h-full items-center justify-center">
      <img
        src={contentUrl}
        alt={filename}
        onError={() => setFailed(true)}
        className="max-h-[80vh] max-w-full rounded-lg border border-panel shadow-lg"
      />
    </div>
  );
}
